import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

export interface Integration {
  id: string;
  name: string;
  description: string;
  icon: string;
  connected: boolean;
  isPlaceholder?: boolean;
}

@Component({
  selector: 'app-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class IntegrationsComponent implements OnInit {
  @ViewChild('integrationModal') integrationModal!: TemplateRef<any>;
  
  selectedIntegrationName: string = '';

  integrations: Integration[] = [
    {
      id: 'powerbi',
      name: 'Microsoft Power BI',
      description: 'Connect to and visualize any data, and seamlessly infuse visuals into the apps you use every day.',
      icon: 'powerbi',
      connected: false
    },
    {
      id: 'datev',
      name: 'Datev',
      description: 'Whether alone and flexibly or together in a partnership or in a team, with us you will find the solution for your needs.',
      icon: 'datev',
      connected: false
    },
    {
      id: 'hubspot',
      name: 'Hubspot',
      description: 'Unite marketing, sales, and customer service on one AI-powered customer platform that delivers results fast.',
      icon: 'hubspot',
      connected: false
    },
    {
      id: 'salesforce',
      name: 'Salesforce',
      description: 'Salesforce is the world\'s leading technology for customer relationship management.',
      icon: 'salesforce',
      connected: false
    },
    {
      id: 'dynamics',
      name: 'Microsoft Dynamics',
      description: 'Become more data-driven and innovative with apps for sales, service, finance, and supply chain operations.',
      icon: 'dynamics',
      connected: false
    }
  ];

  placeholderCards: any[] = [
    {
      id: 'placeholder-1',
      isPlaceholder: true
    }
  ];

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  connectIntegration(integration: Integration): void {
    if (integration.isPlaceholder) {
      this.requestIntegration();
    } else {
      this.selectedIntegrationName = integration.name;
      this.openModal();
    }
  }

  requestIntegration(): void {
    this.selectedIntegrationName = 'a new integration';
    this.openModal();
  }

  openModal(): void {
    this.modalService.open(this.integrationModal, {
      centered: true,
      size: 'md'
    });
  }

  talkToSales(): void {
    window.open('https://www.talonic.com/get-started', '_blank');
  }
}

